import "./Catalog.css";
import CatalogMain from "./CatalogMain";
import CatalogSide from "./CatalogSide";


const CatalogView = (props) => {
	return (
		<div className="Catalog-contentarea flex flex-1 bg-cover bg-center bg-no-repeat">
			<CatalogMain {...props} />
			<CatalogSide {...props} />
		</div>
	);
};

export default CatalogView;
